<div
  class="benefit-card"
  ngClass.lt-md="mobile"
  [ngClass]="getType() + '-benefit-card'"
>
  <div fxLayout="row" fxLayoutAlign="center center" class="image-container">
    <img
      src="{{ imagePath + getType() + '.svg' }}"
      alt="{{ getType() }} benefits"
      [ngClass]="getType()"
      [attr.data-cy]="'benefit-card.image-' + getType()"
    />
  </div>
  <div class="card-title" [attr.data-cy]="'benefit-card.title-' + getType()">
    {{ 'promotional_benefits_' + getType() + '_title' | translate }}
  </div>
  <div
    class="card-content"
    (click)="onPromotionalBenefitsClick($event)"
    [innerHTML]="'promotional_benefits_' + getType() + '_content' | translate"
  ></div>

  <a
    *ngIf="!isInternal()"
    [attr.data-cy]="'benefit-card.link-' + getType()"
    tabindex="-1"
    [href]="getHref() | translate"
    target="_blank"
    class="cta-button"
    appGtm
    [gtmData]="gtmExternalLinkData"
    [gtmOnClick]="true"
  >
    <zelis-button [attr.data-cy]="'benefit-card.button-' + getType()">
      {{ 'promotional_benefits_' + getType() + '_button_content' | translate }}
    </zelis-button>
  </a>

  <div *ngIf="isInternal()" class="cta-button">
    <zelis-button
      [attr.data-cy]="'benefit-card.router-link-' + getType()"
      color="accent"
      [routerLink]="getRoute()"
      queryParamsHandling="preserve"
    >
      {{ 'promotional_benefits_' + getType() + '_button_content' | translate }}
    </zelis-button>
  </div>
</div>
